import React, { useState } from 'react'

import { APIProvider } from '@vis.gl/react-google-maps';
import { MapWidget } from './map';

import './App.css';

function App() {

  const [loaded, setLoaded] = useState(false);
  
  return (
    <div className="App">
      <APIProvider 
        apiKey={"AIzaSyBgfuFAKD2nwoOzhTrvXY4stwTRroT3L68"} 
        libraries={['core']}
        onLoad={() => {
          console.log("map ", window.google.maps);
          setLoaded(true)
        }}
      >
        <MapWidget loaded={loaded} />
      </APIProvider>
    </div>
  );
}

export default App;
